import React from 'react'
import FileUploadButton from '../../../../file/upload/FileUploadButton'
import FileBdList from '../../../../file/bd/FileBdList'
import { useSelector } from 'react-redux'

const SupplierFilesBlock = ({ name, tableOwnerId, tableOwnerType = 'suppliers', type }) => {
    
    const supplier = useSelector(state => state.supplier.supplier)

  return (
    <div className='fileListBlock'>
        <div className='fileListBlock__header'>
            <p>
                {name}
            </p>
            <FileUploadButton
                tableOwnerId={tableOwnerId}
                tableOwnerType={tableOwnerType}
                type={type}
            />
        </div>
        
        <FileBdList 
            type={type}
            files={supplier && supplier.files ? supplier.files : []}
        />
    </div>
  )
}

export default SupplierFilesBlock